<script setup>
const reloadPage = () => window.location.reload();
</script>

<template lang="pug">
  .popup-container
    img(src="/public/error.svg", alt="img")
    h3 發生了一點錯誤...
    p
      |不過沒關係，這只是小插曲！
      br
      |請嘗試重新整理，或返回上一頁繼續操作。
    .button-container
      button.standard(@click="reloadPage") 重新整理
</template>

<style scoped lang="sass">
@use '@assets/styles/common' as *
@use '@assets/styles/mixin' as *

.popup-container
  +flex(center)
  width: 400px
  padding: 40px
  flex-direction: column
  background-color: #fff
  border-radius: 16px
  box-shadow: 0px 0px 40px 0px rgba(25, 25, 25, 0.20)


.popup-container
  & > img
    +size(200px,auto)
    max-width: 100%
  & > h3
    +font(24px,500)
    line-height: 2
    color: #6B6B6B
  & > p
    +font(16px,500)
    line-height: 2
    color: #6B6B6B
    text-align: center

.button-container
  width: 100%
  margin-top: 40px
</style>
